import { apiConnector } from './apiConnector';
import { API } from './api';
import { useState, useEffect } from 'react';


const useLookupData = ({ year, branch, semester, subject, type, shouldFetch, searchTrigger }) => {
  const [lookup, setLookup] = useState(null);
  const [unitDriveIds, setUnitDriveIds] = useState({});

  useEffect(() => {
    const fetchLookup = async () => {
      try {
        const requestParams = { year, branch, subject, semester };
        
        // Log the API request details
        // console.log('🔍 Lookup API Request:', {
        //   endpoint: API.GET_DATA_LOOKUP,
        //   method: 'GET',
        //   params: requestParams,
        //   type: type // type is for frontend only, not sent to API
        // });
        
        // Pass query parameters as the 5th parameter (params)
        const response = await apiConnector('GET', API.GET_DATA_LOOKUP, null, null, requestParams);
        
        // Log the API response
        // console.log('✅ Lookup API Response:', response?.data);
        
        if (response?.data?.success) {
          setLookup(response.data);
          
          // Create object with unit Google Drive IDs
          const unitIds = {};
          if (response.data.units && Array.isArray(response.data.units)) {
            response.data.units.forEach((unit, index) => {
              if (unit.googleDriveId) {
                unitIds[`unit${index + 1}`] = unit.googleDriveId;
                // Or use unit._id as key:
                // unitIds[unit._id] = unit.googleDriveId;
              }
            });
          }
          setUnitDriveIds(unitIds);
          // console.log('📦 Extracted Unit Drive IDs:', unitIds);
        } else {
          console.warn('⚠️ Lookup API returned unsuccessful response');
        }
      } catch (error) {
        console.error('❌ Error fetching lookup:', error);
        console.error('Error response:', error.response?.data);
      }
    };
    
    // Only fetch if shouldFetch is true and all required fields are present
    // Note: 'type' is not needed for API call, it's only used for frontend display logic
    if (shouldFetch && year && branch && semester && subject) {
      // console.log('🚀 Triggering Lookup API call... (Search Trigger:', searchTrigger, ')');
      fetchLookup();
    } else {
      // console.log('⏸️ Lookup API call skipped - waiting for all fields:', {
      //   shouldFetch,
      //   hasYear: !!year,
      //   hasBranch: !!branch,
      //   hasSemester: !!semester,
      //   hasSubject: !!subject,
      //   searchTrigger
      // });
    }
  }, [year, branch, semester, subject, type, shouldFetch, searchTrigger]);
  // console.log(lookup,unitDriveIds)

  return { lookup, unitDriveIds };

};

export default useLookupData;